import { useEffect, useState, FC } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

/**
 *
 * @see https://github.com/react-ga/react-ga/issues/122#issuecomment-668640145
 */
const usePageTracking = (): void => {
    const location = useLocation();
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!window.location.href.includes("localhost") && window.xaStudioConfig?.googleAnalyticsKey) {
            console.log("Initializing Google Analytics with key:", window.xaStudioConfig.googleAnalyticsKey);
            ReactGA.initialize(window.xaStudioConfig?.googleAnalyticsKey);
            setInitialized(true);
        }
    }, []);

    useEffect(() => {
        if (initialized) {
            console.log("Tracking page view:", `${location.pathname}${location.search}`);
            ReactGA.send({ hitType: "pageview", page: `${location.pathname}${location.search}` });
        }
    }, [initialized, location]);
};

export default usePageTracking;

/**
 * Starts page tracking.  Must be used within a Router context.
 * @returns
 */
export const PageTrackingWrapper: FC = () => {
    usePageTracking();
    return null;
};
